import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/arrow-right-landing.svg'
import _imports_1 from '@/assets/icons/icon-question-color.svg'
import _imports_2 from '@/assets/icons/arrow-up-builder-message.svg'


const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "page-wr"
}
const _hoisted_3 = { class: "content-wr" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "house-info-card header-card" }
const _hoisted_7 = { class: "house-info-card-row" }
const _hoisted_8 = { class: "row-value" }
const _hoisted_9 = { class: "house-info-card-row" }
const _hoisted_10 = { class: "row-value" }
const _hoisted_11 = { class: "house-info-card-row" }
const _hoisted_12 = { class: "row-value" }
const _hoisted_13 = {
  key: 0,
  class: "content-design-features"
}
const _hoisted_14 = { class: "house-design" }
const _hoisted_15 = { class: "content-house-and-floorplan" }
const _hoisted_16 = { class: "content-carousel" }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  class: "content-next-floorplan-and-inclusions"
}
const _hoisted_19 = {
  key: 0,
  class: "content-back-facade"
}
const _hoisted_20 = { class: "house-info" }
const _hoisted_21 = { class: "content-info-and-message" }
const _hoisted_22 = { class: "house-info-card-row" }
const _hoisted_23 = { class: "row-value" }
const _hoisted_24 = { class: "house-info-card-row" }
const _hoisted_25 = { class: "row-value" }
const _hoisted_26 = { class: "house-info-card-row final-price" }
const _hoisted_27 = { class: "row-value" }
const _hoisted_28 = { class: "content-button" }
const _hoisted_29 = {
  key: 0,
  class: "icon-question",
  src: _imports_1
}
const _hoisted_30 = {
  key: 1,
  class: "icon-arrow",
  src: _imports_2
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_buton = _resolveComponent("buton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!$setup.loading && $setup.estate)
            ? (_openBlock(), _createBlock($setup["BuilderHeader"], {
                key: 0,
                estate: $setup.estate,
                isReviewQuote: true
              }, {
                stepper: _withCtx(() => [
                  _createVNode($setup["Stepper"], {
                    tabs: [...Object.values($setup.CustomizeHouseStepsReviewQuoteEnum)],
                    step: $setup.CustomizeHouseStepsReviewQuoteEnum.REVIEW_QUOTE,
                    stepType: $setup.StepTypeEnum.CUSTOMIZE_HOUSE_STEPS_REVIEW_QUOTE
                  }, null, 8, ["tabs", "step", "stepType"])
                ]),
                _: 1
              }, 8, ["estate"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "header",
              id: $setup.BuilderStepsIds.HOUSE
            }, [
              _createElementVNode("img", {
                class: "builder-logo",
                src: $setup.quote.selections.builder.logoUrl
              }, null, 8, _hoisted_5),
              _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "title" }, "Your quote is ready!", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row-label" }, "Lot", -1)),
                    _createElementVNode("div", _hoisted_8, _toDisplayString($setup.quote.selections.lot.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row-label" }, "Builder", -1)),
                    _createElementVNode("div", _hoisted_10, _toDisplayString($setup.quote.selections.builder.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "row-label" }, "House Design", -1)),
                    _createElementVNode("div", _hoisted_12, _toDisplayString($setup.quote.selections.house.name), 1)
                  ])
                ]),
                ($setup.isDesktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString($setup.quote.selections.house.name), 1),
                      _createVNode($setup["HouseFeatures"], {
                        features: $setup.house,
                        class: _normalizeClass($setup.isDesktop ? 'house-features' : 'house-features-mobile'),
                        iconSize: 'tiny',
                        directionLogo: true
                      }, null, 8, ["features", "class"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_4),
            _createElementVNode("div", _hoisted_15, [
              ($setup.isDesktop || ($setup.fadeInEffectSlider && !$setup.isDesktop))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["content-house-and-feautures", { 'slide-in': $setup.isButtonClicked && !$setup.isDesktop }])
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("img", {
                        class: "house-design",
                        src: $setup.sliderImages
                      }, null, 8, _hoisted_17)
                    ]),
                    (!$setup.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "content-text" }, "Floor Plans & Inclusions", -1)),
                          _createVNode(_component_buton, {
                            class: "context-logo-next",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onButtonClickSlider()))
                          }, {
                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                              _createElementVNode("img", {
                                class: "logo-arrow-floorplan",
                                src: _imports_0
                              }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              ($setup.isDesktop || (!$setup.fadeInEffectSlider && !$setup.isDesktop))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["content-floorplan-and-info", { 'slide-out': !$setup.isButtonClicked && !$setup.isDesktop }])
                  }, [
                    _createVNode($setup["BuilderFloorplansFeaturesModal"], { houseDesign: $setup.house }, null, 8, ["houseDesign"]),
                    (!$setup.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(_component_buton, {
                            class: "context-logo-back",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onButtonClickSlider()))
                          }, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                              _createElementVNode("img", {
                                class: "logo-arrow-facade",
                                src: _imports_0
                              }, null, -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "content-text" }, "Back to Exterior Facade", -1))
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode($setup["HouseSelectionsCard"], {
                houseName: $setup.quote.selections.house.name,
                selections: $setup.quote.selections
              }, null, 8, ["houseName", "selections"]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", {
                  class: _normalizeClass(["house-info-card", { isOpenInfo: $setup.fadeInEffect }])
                }, [
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "title" }, "Home & Land Package", -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "row-label" }, "Land Price", -1)),
                      _createElementVNode("div", _hoisted_23, _toDisplayString($setup.formatPrice($setup.quote.selections.lot.price)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "row-label" }, "Build Price", -1)),
                      _createElementVNode("div", _hoisted_25, _toDisplayString($setup.formatPrice($setup.quote.selections.house.price)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "row-label" }, "Package Price", -1)),
                      _createElementVNode("div", _hoisted_27, _toDisplayString($setup.formatPrice($setup.packagePrice)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("button", {
                      class: "button default primary request",
                      onClick: $setup.onSecureLot
                    }, "Request a hold on Lot " + _toDisplayString($setup.quote.selections.lot.name), 1),
                    _createElementVNode("button", {
                      class: _normalizeClass(["button default primary message", { changeButton: $setup.fadeInEffect }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openBuildPrice()))
                    }, [
                      _cache[16] || (_cache[16] = _createTextVNode(" How can I lock in this build price", -1)),
                      (!$setup.fadeInEffect)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_29))
                        : (_openBlock(), _createElementBlock("img", _hoisted_30))
                    ], 2)
                  ])
                ], 2),
                _createVNode($setup["BuilderOpenMessageReviewQuote"], {
                  isOpen: $setup.isBuildPrice,
                  lot: $setup.quote.selections.lot.name,
                  type: $setup.BuilderMessageType.BUILD_PRICE,
                  class: _normalizeClass({ isOpen: $setup.fadeInEffect })
                }, null, 8, ["isOpen", "lot", "type", "class"])
              ])
            ]),
            _createVNode($setup["BuilderLoanCalculator"], {
              class: "loan-calculator",
              packagePrice: $setup.packagePrice,
              quote: $setup.quote
            }, null, 8, ["packagePrice", "quote"])
          ])
        ])),
    _createVNode($setup["InitialHoldModal"], {
      isOpen: $setup.isOpenedInitialHoldModal,
      lot: $setup.lotForModal,
      onClose: $setup.onCloseInitialHoldModal,
      onBack: $setup.onCloseInitialHoldModal,
      onSend: $setup.onSendHoldRequest,
      onToPartnerModal: $setup.onOpenPartnerModal
    }, null, 8, ["isOpen", "lot"]),
    _createVNode($setup["InitialHoldWithPartnerModal"], {
      isOpen: $setup.isOpenedInitialHoldModalWithPartner,
      lot: $setup.lotForModal,
      onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.isOpenedInitialHoldModalWithPartner = false)),
      onBack: $setup.backToSelectHoldType,
      onSend: $setup.onSendHoldRequest
    }, null, 8, ["isOpen", "lot"]),
    _createVNode($setup["SuccessInitialHoldModal"], {
      isOpen: $setup.successfulInitialRequestOpened,
      onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.successfulInitialRequestOpened = false)),
      lot: $setup.lotForModal
    }, null, 8, ["isOpen", "lot"])
  ], 64))
}